/* REGULATION 35 campaign page. Temporary: to disable or remove it, see the comment at the top
   of sections/reg35-story.liquid. */
(function(){
  var mqMotion=window.matchMedia("(prefers-reduced-motion: reduce)");
  var mqNarrow=window.matchMedia("(max-width: 860px)");
  var chs=[].slice.call(document.querySelectorAll(".ch"));
  var dots=[].slice.call(document.querySelectorAll(".rail button"));
  /* the rail is navigation: each marker scrolls to the first section carrying that data-ch
     (two sections share ch 5, so first-match is what we want). */
  dots.forEach(function(d){
    d.addEventListener("click",function(){
      var t=document.querySelector('.ch[data-ch="'+d.getAttribute("data-r")+'"]');
      if(!t){return;}
      /* a chapter with a data-lead starts after that lead, not at its section top */
      var ld=(parseFloat(t.getAttribute("data-lead"))||0)*window.innerHeight/100;
      window.scrollTo({top:t.offsetTop+ld,behavior:mqMotion.matches?"auto":"smooth"});
    });
  });
  function ss(a,b,x){var t=Math.min(1,Math.max(0,(x-a)/(b-a)));return t*t*(3-2*t);}
  function pinned(){return !mqMotion.matches && !mqNarrow.matches;}
  var root=document.querySelector(".reg35");
  var hero=document.querySelector(".hero");
  var track=document.querySelector(".rail .track");
  /* On mobile the opening panel is in the page flow, below the store's announcement strip and
     header. --hero-top is how far down the page it starts, so the CSS can size it to the rest of
     the first screen instead of a full screen that runs off the bottom. */
  function heroTop(){
    if(hero){hero.style.setProperty("--hero-top",Math.max(0,Math.round(hero.getBoundingClientRect().top+window.scrollY))+"px");}
  }
  heroTop();
  window.addEventListener("resize",heroTop);

  /* ---------- lightbox ----------
     The archive scans are 2-3x bigger than they render, so a click is worth something.
     ZOOM_CH lists which chapters take part. An image inside a link is left alone, so the
     press cutting still goes to the article. */
  var ZOOM_CH=["1","3","4","5"], zoomable=[], lb=document.getElementById("lb"),
      lbimg=document.getElementById("lbimg"), lbcap=document.getElementById("lbcap"), lbAt=-1, lbFrom=null;
  [].slice.call(document.querySelectorAll(".ch")).forEach(function(sec){
    if(ZOOM_CH.indexOf(sec.getAttribute("data-ch"))<0){return;}
    [].slice.call(sec.querySelectorAll(".obj img, .pop .pack img")).forEach(function(img){
      if(img.closest("a")||img.closest(".nozoom")){return;}   /* .nozoom: shown, never enlarged */
      img.classList.add("zoomable");
      img.tabIndex=0; img.setAttribute("role","button");
      var fig=img.closest("figure"), cap=fig&&fig.querySelector("figcaption");
      zoomable.push({img:img,cap:(cap?cap.textContent:img.alt||"").trim()});
    });
  });
  function lbShow(i){
    if(i<0){i=zoomable.length-1;} if(i>=zoomable.length){i=0;}
    lbAt=i; var it=zoomable[i];
    lbimg.src=it.img.currentSrc||it.img.src; lbimg.alt=it.img.alt||"";
    lbcap.textContent=it.cap;
    /* never blow a scan up past twice its own pixels, or the detail turns to mush */
    lbimg.style.maxWidth=Math.round((it.img.naturalWidth||900)*2)+"px";
  }
  function lbOpen(i){ lbFrom=document.activeElement; lb.hidden=false;
    document.documentElement.style.overflow="hidden"; lbShow(i); lb.querySelector(".lbx").focus(); }
  function lbClose(){ lb.hidden=true; document.documentElement.style.overflow="";
    lbimg.src=""; if(lbFrom&&lbFrom.focus){lbFrom.focus();} }
  zoomable.forEach(function(it,i){
    it.img.addEventListener("click",function(){lbOpen(i);});
    it.img.addEventListener("keydown",function(e){
      if(e.key==="Enter"||e.key===" "){e.preventDefault();lbOpen(i);}});
  });
  lb.addEventListener("click",function(e){
    if(e.target===lb||e.target.tagName==="FIGURE"||e.target.classList.contains("lbx")){lbClose();}});
  lb.querySelector(".lbp").addEventListener("click",function(e){e.stopPropagation();lbShow(lbAt-1);});
  lb.querySelector(".lbn").addEventListener("click",function(e){e.stopPropagation();lbShow(lbAt+1);});
  document.addEventListener("keydown",function(e){
    if(lb.hidden){return;}
    if(e.key==="Escape"){lbClose();}
    else if(e.key==="ArrowLeft"){lbShow(lbAt-1);}
    else if(e.key==="ArrowRight"){lbShow(lbAt+1);}
  });

  function frame(){
    var vh=window.innerHeight,mid=window.scrollY+vh/2,act=0,on=pinned();
    /* The hero is an out-of-flow overlay, so its progress is scroll distance, not geometry.
       HERO_VH must match 1991's data-lead. */
    var HERO_VH=90, hp=Math.min(1,Math.max(0,window.scrollY/(vh*HERO_VH/100)));
    if(hero){hero.style.setProperty("--p",hp.toFixed(4));}
    for(var i=0;i<chs.length;i++){
      var ch=chs[i],top=ch.offsetTop,h=ch.offsetHeight;
      if(mid>=top&&mid<top+h){act=parseInt(ch.getAttribute("data-ch"),10)||0;}
      if(ch===hero){continue;}
      if(!on){continue;}
      /* data-lead holds a chapter still, in vh, before its own progress starts. 1991 uses it
         to wait for the hero overlay to finish fading. */
      var lead=(parseFloat(ch.getAttribute("data-lead"))||0)*vh/100;
      var span=h-vh-lead,p=span>0?(window.scrollY-top-lead)/span:0;
      p=Math.min(1,Math.max(0,p));
      ch.style.setProperty("--p",p.toFixed(4));
      ch.style.setProperty("--in",ss(0.10,0.34,p).toFixed(4));
      ch.style.setProperty("--out",(1-ss(0.80,0.98,p)).toFixed(4));
      ch.style.setProperty("--pin",(ss(0.46,0.63,p)*(1-ss(0.87,1.0,p))).toFixed(4));
      ch.style.setProperty("--flip",ss(0.34,0.60,p).toFixed(4));
    }
    /* how far the end of the page is above the bottom of the window; the CSS clips the fixed rail,
       rule and year bar by this much so they appear to pass under the store footer */
    if(root){root.style.setProperty("--end",Math.max(0,Math.round(vh-root.getBoundingClientRect().bottom))+"px");}
    if(hp<0.98){act=0;}
    for(var j=0;j<dots.length;j++){dots[j].classList.toggle("on",j===act);}
    /* the mobile year bar slides continuously: whole number is the chapter, fraction is
       progress through it */
    if(track){
      var cur=document.querySelector('.ch[data-ch="'+act+'"]'),
          fp=cur?(parseFloat(cur.style.getPropertyValue("--p"))||0):0;
      if(act===0){fp=hp;}
      track.style.setProperty("--i",(act+Math.min(1,Math.max(0,fp))*0.92).toFixed(3));
    }
  }
  /* closing statement: record the mouse position for the CSS red glow (mouse only, never touch) */
  var quote=document.querySelector(".reg35 .quote");
  if(quote && window.matchMedia("(hover: hover)").matches){
    quote.addEventListener("pointermove",function(e){
      if(e.pointerType!=="mouse"){return;}
      var r=quote.getBoundingClientRect();
      quote.style.setProperty("--mx",Math.round(e.clientX-r.left)+"px");
      quote.style.setProperty("--my",Math.round(e.clientY-r.top)+"px");
      quote.classList.add("glow");
    });
    quote.addEventListener("pointerleave",function(){quote.classList.remove("glow");});
  }
  var q=false;
  function onScroll(){if(q)return;q=true;requestAnimationFrame(function(){q=false;frame();});}
  window.addEventListener("scroll",onScroll,{passive:true});
  window.addEventListener("resize",onScroll);
  function stackedMode(){
    if(pinned())return;
    /* whole chapters fade in as blocks (their stage), not the pieces inside them; in the shop, the
       heading lines, each card and the sign-up. The opening panel is on screen already. */
    var bits=[].slice.call(document.querySelectorAll(".ch:not(.hero) > .stage, .shop .in > :not(.grid), .shop .card"));
    if(!("IntersectionObserver" in window)){bits.forEach(function(b){b.classList.add("seen");});return;}
    var io=new IntersectionObserver(function(es){
      es.forEach(function(e){if(e.isIntersecting){e.target.classList.add("seen");io.unobserve(e.target);}});
    },{rootMargin:"0px 0px -12% 0px"});
    bits.forEach(function(b){b.classList.add("fade");io.observe(b);});
  }
  frame();stackedMode();
})();
